import type { HeroActivity } from '@/modules/game-domain/hero-activity.types';

const kinds = new Set(['dead','combat','encounter','decision','npc_walk','npc_service','rest','rest_walk','writing_biography','investigating_scene','return','travel','escort','handover','work','idle']);
/** Accept only the public server projection. Unknown/incomplete wire state remains unknown. */
export function parseHeroActivity(raw: unknown): HeroActivity | undefined {
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return undefined;
  const value = raw as Record<string, unknown>;
  if (typeof value.kind !== 'string' || !kinds.has(value.kind)) return undefined;
  const result: HeroActivity = {kind: value.kind};
  for (const key of ['targetTownId','targetNpcId','nextTownId'] as const) {
    const id = value[key];
    if (id !== undefined) {
      if (!Number.isSafeInteger(id) || Number(id) <= 0) return undefined;
      result[key] = Number(id);
    }
  }
  if (value.targetName !== undefined) {
    if (typeof value.targetName !== 'string' || value.targetName.length > 128) return undefined;
    result.targetName = value.targetName;
  }
  for (const key of ['npcType','restKind'] as const) {
    const code = value[key];
    if (code !== undefined) {
      if (typeof code !== 'string' || !/^[a-z_.]{0,64}$/.test(code)) return undefined;
      result[key] = code;
    }
  }
  return result;
}
